/**
 * Converts the first character of string to upper case.
 *
 * @param {string} str
 * @returns {string} str
 */
export var upperFirst = function (str) { return str.charAt(0).toUpperCase() + str.substr(1); };
//# sourceMappingURL=upperFirst.js.map